import React from "react";
import "./NoData.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NoData = ({ icon, description }) => {
	return (
		<div className="no-data flex direction-col justify-content-center align-items-center" style={{ width: "100%" }}>
			<FontAwesomeIcon icon={icon} size="3xl" />
			<div className="text text-body--2 mt-8">{description}</div>
		</div>
	);
};

export default NoData;
